import ProductDescription from './ProductDescription'

const BSInfantMeatsProduct = {
  ...ProductDescription,
  category: '13',
  subCategory: '001BS',
  IsBroadband: true,
  PackageType: '',
  Size: '2.5 ounces only',
  MultiPackageType: false,
  MultiPackageCount: null,
  Organic: false,
  NoAdditionalIngredients: false,
}

export default BSInfantMeatsProduct
